import { nanoid } from 'nanoid';
import Icon from '@/core/icon.js';

/*
  Squelette d'une carte de résultat. Il reprend EXACTEMENT les hauteurs et marges de la carte
  réelle (components/search/results/space.js) : visuel `h-80 lg:h-[20vw]`, bloc texte `py-2`
  avec une ligne de 24px (type + note), un titre de 20px et une ligne méta de 20px. Avant, le
  visuel faisait `h-[80vw] sm:h-80` et le texte avait ses propres marges : la grille sautait
  au passage squelette -> résultats.
*/
function Loading() {
  return (
    <div className="blink">
      <div className="relative h-80 overflow-hidden rounded-[10px] bg-purple-5/10 lg:h-[20vw]">
        <div className="absolute right-3 top-3 px-2 py-2"><Icon className="size-5 stroke-current text-white/70" name="heart" /></div>
      </div>
      <div className="py-2 text-[15px] leading-6">
        <div className="flex h-6 items-center justify-between">
          <span className="block h-4 w-2/5 rounded bg-purple-5/10" />
          <span className="block h-4 w-20 rounded bg-purple-5/10" />
        </div>
        <div className="mb-[3px] mr-11 flex h-5 items-center">
          <span className="block h-3.5 w-3/4 rounded bg-purple-5/10" />
        </div>
        <div className="mt-[4px] flex h-5 items-center gap-x-6">
          <span className="block h-4 w-24 rounded bg-purple-5/10" />
          <span className="block h-4 w-14 rounded bg-purple-5/10" />
          <span className="block size-5 rounded-full bg-purple-5/10" />
        </div>
      </div>
    </div>
  );
}

function SpaceLoading() {
  return <div key={nanoid()}>
    {/* WEA-157 : plus d'id contentSearchList2257 ici — il est porté une fois pour tous les états
        par components/search/results.js (sinon deux éléments partageaient le même id). */}
    <div className="grid grid-cols-1 px-6 pt-4 pb-6 sm:grid-cols-2 xl:grid-cols-3 gap-7 lg:gap-x-6 lg:gap-y-7 lg:px-8 lg:pt-4 lg:pb-8 group">
      {'1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20'.split(',').map((k) => <Loading key={`searchpagespaceloading${k}`} />)}
    </div>
         </div>;
}

export default SpaceLoading;
